<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
  import TemplateSlider from './TemplateSlider'

  export default {
    name: 'TopStoryTeaser',
    components: {
      TemplateSlider,
    },
    props: {
      data: {
        type: Object,
        default: _ => {},
      },
    },
    data() {
      return {
        model: 0,
        cycle: false,
      }
    },
    computed: {
      options() {
        return this.data.options
      },
      articles() {
        return this.data.results
      },
    },
    watch: {
      'options'(val) {
        this.cycle = val && val.isCircle
      },
    },
  }
</script>
